export default __webpack_public_path__ + "static/media/black-right-arrow-small.1768c623.svg";